import styled from 'styled-components';

export const ChatContainer = styled.div`
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 400px;
  height: 600px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  z-index: 1000;
  
  @media (max-width: 480px) {
    width: 100%;
    height: 100%;
    bottom: 0;
    right: 0;
    border-radius: 0;
  }
`;

export const ChatHeader = styled.div`
  background: #c71618;
  color: white;
  padding: 16px 20px;
  border-radius: 12px 12px 0 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  
  h3 {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
  }
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  color: white;
  font-size: 24px;
  cursor: pointer;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background 0.2s;
  
  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }
`;

export const MessagesList = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 20px;
  background: #f9f9f9;
`;

export const MessageItem = styled.div<{ senderType: string }>`
  display: flex;
  flex-direction: column;
  margin-bottom: 12px;
  align-items: ${(props) => (props.senderType === 'user' ? 'flex-end' : 'flex-start')};
`;

export const MessageBubble = styled.div<{ senderType: string }>`
  max-width: 70%;
  padding: 10px 14px;
  border-radius: 18px;
  word-wrap: break-word;
  
  ${(props) =>
    props.senderType === 'user'
      ? `
    background: #c71618;
    color: white;
  `
      : props.senderType === 'admin'
      ? `
    background: #e0e0e0;
    color: #333;
  `
      : `
    background: #fff3cd;
    color: #856404;
    border: 1px solid #ffeaa7;
  `}
`;

export const MessageTime = styled.div`
  font-size: 11px;
  color: #999;
  margin-top: 4px;
  padding: 0 4px;
`;

export const InputArea = styled.div`
  padding: 16px;
  border-top: 1px solid #e0e0e0;
  display: flex;
  gap: 8px;
  background: white;
  border-radius: 0 0 12px 12px;
`;

export const Input = styled.input`
  flex: 1;
  padding: 10px 14px;
  border: 1px solid #e0e0e0;
  border-radius: 20px;
  font-size: 14px;
  outline: none;
  
  &:focus {
    border-color: #c71618;
  }
  
  &:disabled {
    background: #f5f5f5;
    cursor: not-allowed;
  }
`;

export const SendButton = styled.button`
  padding: 10px 20px;
  background: #c71618;
  color: white;
  border: none;
  border-radius: 20px;
  cursor: pointer;
  font-weight: 600;
  transition: background 0.2s;
  
  &:hover:not(:disabled) {
    background: #a01214;
  }
  
  &:disabled {
    background: #ccc;
    cursor: not-allowed;
  }
`;
